package com.macrofocus.nastac.ui.layer.legacy

import com.macrofocus.nastac.data.GeoEPRAgg
import com.macrofocus.nastac.data.HEG
import deckgl.MVTLayer
import js.objects.unsafeJso
import org.mkui.color.colorOf
import org.mkui.colormap.ColorMapFactory
import org.mkui.palette.PaletteFactory

fun createEthnicityLayer(year: Int) : MVTLayer<Any> {
    val paletteFactory = PaletteFactory.instance
    val colorMapFactory = ColorMapFactory(paletteFactory)

    val palette = paletteFactory.createDefaultQualititativePalette()
//    val interpolated = InterpolatedPalette(palette)
//    interpolated.mode.value = InterpolatedPalette.Mode.Bands
    val colormap = colorMapFactory.createCategoricalColorMap(HEG.ethnicNames.union(GeoEPRAgg.ethnicNames), false, palette)
    colormap.setColor("italian [org]", colorOf(180, 0, 180))
    colormap.setColor("german [l5]", colorOf(127, 127, 127))
//    colormap.setColor("croatian [org]", colorOf(127, 127, 127))
    colormap.setColor("greek [l2]", colorOf(128, 64, 0))
    colormap.setColor("serbian [org]", colorOf(0, 0, 255))

    val function = { d: dynamic ->
        val ethnicName = d.properties.EthnicName as String
        val color = colormap.getColor(ethnicName)
        if(color != null) {
            println("$ethnicName -> ${color.toHTMLColor()}")
            arrayOf(color.r.toInt(), color.g.toInt(), color.b.toInt(), 127)
        } else {
            arrayOf(127, 127, 127, 127)
        }
//        if (ethnicName.startsWith("f"))
//            arrayOf(255, 127, 127, 127) else arrayOf(127, 127, 127, 127)
    }

    val heg = MVTLayer<Any>(unsafeJso {
        id = "heg-$year"
        this.data = "/martin/ethnicity/${year}"

        this.pickable = true
        asDynamic().stroked = false
        asDynamic().filled = true
        asDynamic().extruded = false
        asDynamic().pointType = "circle"
//        lineWidthScale = 20
        asDynamic().lineWidthMinPixels = 1
        asDynamic().getFillColor = function
        asDynamic().getLineColor = { d : dynamic -> arrayOf(0,0,0, 127) }
        asDynamic().getPointRadius = 100
        asDynamic().getLineWidth = 1
        asDynamic().getElevation = 30
    })
    return heg
}